import React from "react"
import BackgroundImage from "gatsby-background-image"
import EquipList from "./equipList"


const LaserEquip = ({ equip = null, images = [] }) => {
  if (equip) {
    return (
      <section className="equip-laser">
        <h2>{equip.title}</h2>
        <h3>{equip.classification.title}</h3>
        <p>{equip.classification.description}</p>
        {(images.length > 0) &&
          <div className="equip-laser__images">
            {images.map(({ image }) => (
              <div
                className="equip-laser__image-wrapper"
                key={image.fluid.originalName}
              >
                <BackgroundImage
                  key={image.fluid.originalName}
                  className="image"
                  fluid={image.fluid}
                  alt={image.fluid.originalName}
                />
              </div>
            ))}
          </div>
        }
        <h3>{equip.description.title}</h3>
        <p>{equip.description.description}</p>
        <EquipList data={equip.features} />
      </section>
    )
  } else {
    return null
  }
}

export default LaserEquip